// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { LayoutState, BottomRightPortalState } from '../../../../common/types.tsx';

export const registerBottomRightCornerContainer =
	(ref: HTMLElement | null | undefined): Action<LayoutState> =>
	({ setState, getState }) => {
		const { bottomRightCorner } = getState();

		setState({
			bottomRightCorner: {
				...bottomRightCorner,
				container: ref ?? undefined,
			},
		});
	};

export const insertBottomRightCornerPortal =
	(item: BottomRightPortalState): Action<LayoutState, void, number> =>
	({ setState, getState }) => {
		const { bottomRightCorner } = getState();
		const { portals } = bottomRightCorner;
		const sorted = [item, ...portals].sort((a, b) => b.orderFromRight - a.orderFromRight);
		const index = sorted.findIndex((portal) => portal.id === item.id);

		setState({
			bottomRightCorner: {
				...bottomRightCorner,
				portals: sorted,
			},
		});

		return index;
	};

export const removeBottomRightCornerPortal =
	(id: string): Action<LayoutState> =>
	({ setState, getState }) => {
		const { bottomRightCorner } = getState();
		const { portals } = bottomRightCorner;

		setState({
			bottomRightCorner: {
				...bottomRightCorner,
				portals: portals.filter((portal) => portal.id !== id),
			},
		});
	};
